import axios from "axios";

import { getNotificationsApiUrl } from "src/utils/get-api-url";

const baseUrl = getNotificationsApiUrl()

export function getAll() {
    return axios.get(`${baseUrl}`)
}

export function markAllAsRead(ids) {
    return axios.put(`${baseUrl}/view`, { ids })
}

export function deleteAll() {
    return axios.delete(`${baseUrl}`)
}